<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
a {
  word-break: break-all;
}
.shop-card {
  margin-top: 20px;
}

#app {
  height: 100%;
}

.hidden {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue